import React from "react";
import { Input } from "reactstrap";
import { LoginInput, LoginButton } from "../styled";

const BVNVerifyingSpinner = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem 1rem",
      backgroundColor: "#f8f9fa",
      borderRadius: "8px",
      marginBottom: "1rem",
    }}
  >
    <div
      style={{
        width: "40px",
        height: "40px",
        border: "3px solid #e0e0e0",
        borderTop: "3px solid #007bff",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        marginBottom: "1rem",
      }}
    />
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
    <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>
      Verifying your BVN information...
    </p>
  </div>
);

export const Step2BVNVerification = ({
  bvn,
  setBvn,
  dob,
  setDob,
  bvnUserDetails,
  bvnError,
  stepErrors,
  setStepErrors,
  setBvnError,
  onVerify,
  onPrevious,
  isVerifying,
  userType,
}) => {
  const isCompany = userType === "COMPANY";

  return (
    <LoginInput>
      {isVerifying && <BVNVerifyingSpinner />}

      {bvnError && (
        <div
          style={{
            color: "#e20d0d",
            fontSize: "13px",
            marginBottom: "1rem",
            padding: "1rem",
            backgroundColor: "#fee",
            borderRadius: "4px",
          }}
        >
          {bvnError}
        </div>
      )}

      <div className="mb-4" style={{ opacity: isVerifying ? 0.5 : 1, pointerEvents: isVerifying ? "none" : "auto" }}>
        <label>
          {isCompany ? "Contact's BVN (11 digits)" : "BVN (11 digits)"}
        </label>
        <div className="input-group">
          <Input
            type="text"
            className="form-control"
            placeholder={isCompany ? "Enter contact's 11-digit BVN" : "Enter your 11-digit BVN"}
            maxLength="11"
            value={bvn}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setBvn(value);
              setStepErrors({ ...stepErrors, bvn: "" });
              setBvnError("");
            }}
            disabled={isVerifying}
          />
        </div>
        {stepErrors.bvn && <h3>{stepErrors.bvn}</h3>}
      </div>

      <div className="mb-4" style={{ opacity: isVerifying ? 0.5 : 1, pointerEvents: isVerifying ? "none" : "auto" }}>
        <label>Date of Birth</label>
        <div className="input-group">
          <Input
            type="date"
            className="form-control"
            value={dob}
            onChange={(e) => {
              setDob(e.target.value);
              setStepErrors({ ...stepErrors, dob: "" });
              setBvnError("");
            }}
            disabled={isVerifying}
          />
        </div>
        {stepErrors.dob && <h3>{stepErrors.dob}</h3>}
      </div>

      <div style={{ fontSize: 12, marginTop: 8, color: "#888888" }}>
        <p style={{ margin: "0.5rem 0", lineHeight: "1.5" }}>
          Kindly note that we collect your BVN information as a regulatory KYC
          requirement and to ensure a secure and compliant experience for all
          our users.
        </p>
        <p style={{ margin: "0.5rem 0", lineHeight: "1.5" }}>
          To get your BVN dial <strong>*565*0#</strong> on your registered number.
        </p>
      </div>

      {bvnUserDetails && (
        <div
          style={{
            backgroundColor: "#f5f9ff",
            border: "1px solid #c1e0ff",
            borderRadius: "8px",
            padding: "1rem",
            marginBottom: "1.5rem",
          }}
        >
          <h4
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#1c448d",
              margin: "0 0 0.75rem 0",
            }}
          >
            User Details Retrieved:
          </h4>
          <p
            style={{
              margin: "0.5rem 0",
              fontSize: "14px",
              color: "#333333",
            }}
          >
            <strong style={{ fontWeight: "600", color: "#1c448d" }}>
              Name:
            </strong>{" "}
            {bvnUserDetails.firstName} {bvnUserDetails.lastName}
          </p>
          <p
            style={{
              margin: "0.5rem 0",
              fontSize: "14px",
              color: "#333333",
            }}
          >
            <strong style={{ fontWeight: "600", color: "#1c448d" }}>
              Phone:
            </strong>{" "}
            {bvnUserDetails.phoneNumber || bvnUserDetails.mobile || "N/A"}
          </p>
        </div>
      )}

      <LoginButton>
        <div className="text-center mt-5">
          <button
            type="button"
            className="btn btn-secondary px-5 mb-2"
            onClick={onPrevious}
            disabled={isVerifying}
            style={{ marginRight: "10px" }}
          >
            Previous
          </button>
          <button
            type="button"
            className="btn btn-primary px-5 mb-2"
            onClick={onVerify}
            disabled={isVerifying}
          >
            {isVerifying ? "Verifying..." : "Verify BVN"}
          </button>
        </div>
      </LoginButton>
    </LoginInput>
  );
};
